import { SwalMessage, ToastMessage, turkishToEnglish } from '../../Tools'

var ProductListing = function () {

    var form;
    var listing;
    var template;
    var searchTimeout; // Debounce

    // Debounce fonksiyonu
    var debounce = function(func, wait) {
        return function() {
            var context = this;
            var args = arguments;
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(function() {
                func.apply(context, args);
            }, wait);
        };
    };

    // sayfa tipi
    var type;

    // sıralama
    var orderElement;

    // limit
    var limitElement;
    var itemLimit;


    var gridCount = 2;

    // sayfalama
    var ajaxScroll;
    var currentPage = 1;
    var lastPage;
    var nextPageUrl;

    // arama
    var searchValue;

    var isFetching = false;


    // listeleme fetch metodu
    var fetchHandle = function (url = apiUrl + '/ProductSearch') {

        // if (!isFetching) {
        //     return;
        // }

        return new Promise(function (resolve, reject) {
            let data = {}

            // kampanya id
            if (form.getAttribute('data-discount-id')) {
                data.discount = form.getAttribute('data-discount-id');
            }

            // kategori id
            if (form.getAttribute('data-category-id')) {
                data.category = form.getAttribute('data-category-id');
            }

            // etiket adı
            if (form.getAttribute('data-tag-name')) {
                data.tag_name = form.getAttribute('data-tag-name');
            }

            // listeleme id
            if (form.getAttribute('data-listing-id')) {
                data.listing_id = form.getAttribute('data-listing-id');
            }

            // seri id
            if (form.getAttribute('data-series-id')) {
                data.series_id = form.getAttribute('data-series-id');
            }

            // seri sub id
            if (form.getAttribute('data-sub_series-id') && form.getAttribute('data-sub_series-slug') ) {
                data.series_sub_id = form.getAttribute('data-sub_series-id');
                data.series_sub_slug = form.getAttribute('data-sub_series-slug');
            }

            // tip gönderme
            if (type) {
                data.type = type;
            }

            if (itemLimit || itemLimit > 0) {
                data.limit = itemLimit;
            }

            if (limitElement && limitElement.value) {
                data.limit = limitElement.value;
            }

            if (orderElement && orderElement.value) {
                data.order = orderElement.value;
            }

            if (searchValue) {
                data.search = searchValue;
            }

            // Sayfa numarasını ekle
            if (currentPage) {
                data.page = currentPage;
            }

            data.limit = 5;

            form.querySelector('.loading').classList.remove('d-none');

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`Hata: ${response.status}`);
                    }
                    return response.json();
                })
                .then(xhr => {
                    // console.log(xhr);
                    let products = xhr;
                    if (data.limit) {
                        products = xhr.data
                    }
                    if (ajaxScroll) {
                        currentPage = xhr.current_page;
                        nextPageUrl = xhr.next_page_url
                        lastPage = xhr.last_page - 1
                    }


                    let count = form.querySelector('.title .count')
                    if (count) {
                        count.classList.remove('d-none')
                        //console.log(xhr.total);
                        count.querySelector('span').innerText = '(' + xhr.total + ')'
                    }

                    products.forEach(function (product) {
                        var productClone = template.cloneNode(true);

                        productClone.classList.remove('d-none')
                        productClone.removeAttribute('data-product-template')
                        productClone.setAttribute('data-product', '')

                        let id = product.id
                        productClone.querySelector('[data-product-basket]').setAttribute('data-product-id', id)

                        let name = JSON.parse(product.title)[langCodeLong];
                        if (name == null || name == undefined) {
                            name = JSON.parse(product.title)[langCodeLongDefault];
                        }
                        productClone.querySelector('.card-title a').innerText = name;

                        let slug = JSON.parse(product.slug)[langCodeLong];
                        if (slug == null || slug == undefined) {
                            slug = JSON.parse(product.slug)[langCodeLongDefault];
                        }
                        productClone.querySelectorAll('a').forEach(function (item) {
                            item.setAttribute('href', productUrl + slug);
                            item.setAttribute('title', name);
                        })



                        let picture = JSON.parse(product.thumbnail)[langCodeLong];
                        if (picture == null || picture == undefined) {
                            picture = JSON.parse(product.thumbnail)[langCodeLongDefault];
                        }
                        productClone.querySelector('.card-img-top').setAttribute('src', picture);
                        productClone.querySelector('.card-img-top').setAttribute('alt', name);

                        let price = product.sales_price
                        if (product.discount) {
                            price = product.discount.discount_price

                            productClone.querySelector('.discount').classList.remove('d-none')

                            if (product.discount.amount_type == 'percent') {
                                productClone.querySelector('.discount span').innerText = product.discount.discount_rate

                            } else if (product.discount.amount_type == 'constant') {
                                if (currency.symbol_first) {
                                    product.discount.discount_amount = product.discount.discount_amount + ' ' + currency.symbol
                                } else {
                                    product.discount.discount_amount = currency.symbol + ' ' + product.discount.discount_amount
                                }
                                productClone.querySelector('.discount .rate').innerText = product.discount.discount_amount
                            }
                        }
                        if (product.is_new) {
                            productClone.querySelector('.new-tag').classList.remove('d-none')
                        }

                        price = currencyFormat.from(price);
                        // console.log(price);
                        if (product.discount) {
                            let listPrice = currencyFormat.from(product.sales_price);
                            productClone.querySelector('.price span').innerText = currencyFormat.to(price)
                            productClone.querySelector('.price small').innerText = currencyFormat.to(listPrice)
                        } else {
                            productClone.querySelector('.price span').innerText = currencyFormat.to(price)
                            productClone.querySelector('.price small').classList.add('d-none')
                        }

                        productClone.querySelector('[data-product-like]').setAttribute("data-product-id", id)

                        var placeholders = productClone.querySelectorAll('.placeholder')
                        placeholders.forEach(function (placeholder) {
                            placeholder.classList.remove('placeholder')
                        })

                        // değerlendirme
                        let commentTotal = product.comments.total ?? 0;
                        let commentRating = product.comments.rating ?? 0;

                        productClone.querySelector('.stars span').innerText = "(" + commentTotal + ")";
                        var starsContainer = productClone.querySelector('.stars');

                        var stars = starsContainer.querySelectorAll('.fa-star');
                        for (var i = 0; i < commentRating; i++) {
                            stars[i].classList.add('text-warning');
                        }

                        listing.appendChild(productClone);
                    })

                    // tooltip aktifleştirme
                    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
                    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

                    isFetching = false;

                    resolve();

                    form.querySelector('.loading').classList.add('d-none');
                })
                .catch(error => {
                    reject(error);

                    form.querySelector('.loading').classList.add('d-none');
                });
        });
    }


    // form yüklendiğinde
    var formHandle = async function () {

        // gösterilecek veri limiti
        if (form.getAttribute('data-limit')) {
            itemLimit = form.getAttribute('data-limit')
        }

        // limit
        $(form).on('change', limitElement, async function () {
            if (!isFetching) {
                $('[data-product]').remove();
                currentPage = 1; // Sayfa numarasını sıfırla
                isFetching = true;
                await fetchHandle();
            }
        });

        // sıralama
        $(form).on('change', orderElement, async function () {
            if(!isFetching){
                $('[data-product]').remove();
                currentPage = 1; // Sayfa numarasını sıfırla
                isFetching = true;
                await fetchHandle();
            }
        });

        // listeleme
        $(form).on('click', '[data-grid-count]', function (event) {
            event.preventDefault();

            $('[data-grid-count]').removeClass('active')
            $(this).toggleClass('active')

            let size = this.getAttribute('data-grid-count');


            let products = listing.querySelectorAll('[data-product]')
            products.forEach(function (product) {

                var currentClass = product.className.substr(0, 8);

                $(product).removeClass('col-md-' + gridCount).addClass('col-md-' + size);

                // product.classList.remove(currentClass)
                // product.classList.add('col-md-' + size)

            })
            gridCount = size;


        });

        // scroll ile veri listeleme
        $(window).on('scroll', async function () {
            if (!isFetching && ajaxScroll && ($(document).height() - $(window).height()) - $(window).scrollTop() <= 1200) {
                if (currentPage <= lastPage) {
                    isFetching = true;
                    currentPage++; // Sayfa numarasını artır
                    await fetchHandle();
                }
            }
        });

        // kategori içerisinde arama anahtarı
        $(document).on('keyup', '[data-product-search-input]', debounce(async function() {
            if (!isFetching && ajaxScroll) {
                let baseSearchValue = form.getAttribute('data-search-value') || '';
                let currentValue = this.value?.trim() || '';
                
                // Arama değerlerini temizle ve birleştir
                let searchTerms = [];
                
                // Base search value varsa ekle
                if (baseSearchValue) {
                    // Virgülle ayrılmış terimleri işle
                    searchTerms = baseSearchValue.split(',')
                        .map(term => turkishToEnglish(term.trim()))
                        .filter(term => term);
                }
                
                // Mevcut değer varsa ekle
                if (currentValue) {
                    // Boşlukla ayrılmış terimleri virgülle ayır
                    let currentTerms = currentValue.split(' ')
                        .map(term => turkishToEnglish(term.trim()))
                        .filter(term => term);
                    
                    searchTerms = [...searchTerms, ...currentTerms];
                }
                
                // Temiz bir arama sorgusu oluştur
                searchValue = searchTerms.join(',');
                
                $('[data-product]').remove();
                currentPage = 1; // Sayfa numarasını sıfırla
                isFetching = true;
                await fetchHandle();
            }
        }, 500)); // 500ms bekleyecek


    }

    var handleExternal = function () {

        // ürün beğeni
        $(document).on('click', '[data-product-like]', function (event) {
            event.preventDefault();

            let thisButton = this;

            let productId = thisButton.getAttribute('data-product-id');
            let userId = thisButton.getAttribute('data-user-id');

            if (!userId) {
                ToastMessage('1', translate.product_like, translate.product_like_login)

                let button = document.querySelector('.auth-buttons');
                if (!button.querySelector('.dropdown-menu').classList.contains('show')) {
                    button.querySelector('.btn-auth').click()
                }

                return;
            }

            let data = {
                user_id: userId,
                product_id: productId,
            }

            $.ajax({
                url: apiUrl + '/UserProductLike',
                type: "POST",
                dataType: "json",
                data: data,
                error: function error(xhr) {
                    ToastMessage('1', translate.product_like, xhr.responseJSON.text ?? xhr.responseJSON.message)
                },
                success: function success(xhr) {
                    ToastMessage('0', translate.product_like, xhr.text ?? xhr.message)
                }
            });
        })
    }

    return {
        init: async function () {
            handleExternal();
            let forms = document.querySelectorAll('[data-product-list-form]')
            for (let element of forms) {
                form = element;
                if (!form) {
                    continue;
                }
                listing = form.querySelector('[data-product-listing] .row')
                template = form.querySelector('[data-product-template]')
                type = form.getAttribute('data-product-list-type') ? form.getAttribute('data-product-list-type') : ''
                orderElement = form.querySelector('[data-product-order]')
                limitElement = form.querySelector('[data-product-limit]')
                ajaxScroll = form.getAttribute('data-ajax-scroll')
                searchValue = form.getAttribute('data-search-value') ? form.getAttribute('data-search-value') + ',' : ''
                formHandle();

                // isFetching = true;
                await fetchHandle();
            }
        },
    };

}();

$(function () {
    ProductListing.init();
});